import React, { useState, useEffect } from "react";
import { environment } from "../../environment";
import axios from "axios";
import { Form, Button, Dropdown } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { LinkContainer } from "react-router-bootstrap";
import { fileURLToPath } from "url";
import NavbarNew from "../Components/NavbarNew";

const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const UserFeedback = ({ history }) => {
  const [customers, setCustomers] = useState([]);
  const [email, setEmail] = useState("");
  const [customerCount, setCustomerCount] = useState("");
  const [totalWeightage, setTotalWeightage] = useState([{}]);
  const [updatedDate, setUpdatedDate] = useState([]);
  let totalResponseWaitageArray = [{}];
  let ResponseWaitageArray = [];
  let customersArray = [];
  let master_dropdown = [];
  master_dropdown = [
    {
      questionMasterName: "Customer Feedback",
      questionMasterId: 1,
    },
    {
      questionMasterName: "Voluntary Feedback(Before using purifier)",
      questionMasterId: 2,
    },
    {
      questionMasterName: "Voluntary Feedback(After using purifier)",
      questionMasterId: 3,
    },
  ];

  useEffect(() => {
    let _id = JSON.parse(localStorage.getItem("user"))._id;
    console.log("usersbyfilter", _id);
    axios
      // .post(environment.dap_url + "users/getUsersByfilters", {
      //   filters: { userType: "CUSTOMER_USER", parentId: _id, isDeleted: false },
      // })
      .get(environment.dap_url + "questionnarieApi/allcustomerfeedbackDetails")
      .then((res) => {
        let filteredData = res.data.customers.filter(
          (item) => item.userType === "CUSTOMER_USER"
        );

        // filteredData.sort(function (a, b) {
        //   return (
        //     new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
        //   );
        // });

        setCustomers(filteredData);
        setCustomerCount(filteredData.length);
        console.log(filteredData);
        //getTotalWeighatge(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const columns = [
    {
      dataField: "sl.no",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },
    {
      dataField: "lastResponseAt",
      text: "Date",
      sort: true,
      formatter: (dataField) => {
        // const urLength = row.questionData.length;
        // const urData = row.questionData[urLength - 1]
        // if (urData !== undefined) {
        //   const date = new Date(urData.updatedAt);
        //   const isValidDate = !isNaN(date.getTime());
        //   const formattedDate = isValidDate
        //     ? `${date.getDate().toString().padStart(2, "0")}-${(
        //       date.getMonth() + 1
        //     )
        //       .toString()
        //       .padStart(2, "0")}-${date.getFullYear().toString()}`
        //     : "";
        //   console.log(formattedDate);
        //    return formattedDate
        // }
        let dateArr = dataField.split("T")[0].split("-");
        return dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
      },
    },
    {
      dataField: "organization",
      text: "Organisation",
      sort: true,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      // formatter: (cell, row) => `${row.userFirstName} ${row.userLastName}`,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
    },
    {
      dataField: "phone",
      text: "Phone",
      sort: true,
    },
    {
      dataField: "address",
      text: "Address",
      sort: true,
    },
    {
      dataField: "userMongoId",
      text: "Customer Feedback",
      sort: false,
      formatter: (dataField) => {
        return (
          <div>
            <LinkContainer
              to={`/viewResponse/${dataField}/1`}
              style={{
                float: "center",
              }}
            >
              <Button variant="light" className="btn-sm ">
                View
                <i className="fa fa-eye"></i>
              </Button>
            </LinkContainer>
            {/* <Dropdown alignRight>
              <Dropdown.Toggle variant="transparent">
                <span className="btn">
                  Select Feedback Type<i className="mdi mdi-chevron-down"></i>{" "}
                </span>
              </Dropdown.Toggle>

              <>
                <div>
                  <Dropdown.Menu>
                    {master_dropdown.map((element) => (
                      <Dropdown.Item
                        key={element.questionMasterId}
                        onClick={() =>
                          viewResponse(dataField, element.questionMasterId)
                        }
                      >
                        {element.questionMasterName}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </div>
              </>
            </Dropdown> */}
          </div>
        );
      },
    },
  ];

  const defaultSorted = [
    {
      dataField: "questionResponses[0].createdAt",
      order: "desc",
    },
  ];

  return (
    <>
      <div className="container-fluid">
        <NavbarNew />
        <h4 className="card-title">CUSTOMERS</h4>
        <div className="row">
          <div className="col-12">
            <ToolkitProvider
              keyField="id"
              bootstrap4
              data={customers}
              columns={columns}
              search
            >
              {(props) => (
                <div>
                  <div className="d-flex align-items-center">
                    <p className="mb-2 mr-2">Search in table:</p>
                    <SearchBar {...props.searchProps} />
                  </div>
                  <BootstrapTable
                    defaultSorted={defaultSorted}
                    pagination={paginationFactory()}
                    {...props.baseProps}
                    wrapperClasses="table-responsive"
                  />
                </div>
              )}
            </ToolkitProvider>
          </div>
        </div>
      </div>

      {/* <h5 style={{ marginLeft: "5%" }}>
        Total number of Customers: {customerCount}
      </h5> */}
    </>
  );
};

export default UserFeedback;
